import { Chip, RadioChip } from "@/components/strategy/Chip";

const DURATIONS = [
    { value: 7, label: "7 days", caption: "sprint" },
    { value: 15, label: "15 days", caption: "half month" },
    { value: 30, label: "30 days", caption: "full ramp" },
];

export const GOAL_OPTIONS = [
    "Brand Awareness",
    "Direct Sales",
    "Lead Generation",
    "Community Growth",
    "Thought Leadership",
];

export default function Step2Duration({ form, updateField, toggleArrayField }) {
    const goalCap = form.goals.length >= 3;
    return (
        <div
            className="flex flex-col gap-7"
            data-testid="strategy-step-2"
        >
            <div className="flex flex-col gap-2">
                <h3 className="text-xl font-medium text-[#E8ECF5]">
                    How long and what are you going after?
                </h3>
                <p className="font-mono text-[11px] italic text-[#8A93A6]">
                    Pick a runway and up to 3 goals. The roadmap compounds across
                    weeks to hit them.
                </p>
            </div>

            <div className="flex flex-col gap-3">
                <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                    duration
                </label>
                <div className="flex flex-wrap gap-3" data-testid="strategy-duration-group">
                    {DURATIONS.map((d) => (
                        <RadioChip
                            key={d.value}
                            label={d.label}
                            caption={d.caption}
                            selected={form.duration_days === d.value}
                            onSelect={() => updateField("duration_days", d.value)}
                            testId={`strategy-duration-${d.value}`}
                        />
                    ))}
                </div>
            </div>

            <div className="flex flex-col gap-3">
                <div className="flex items-end justify-between gap-2">
                    <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                        goals · pick 1–3
                    </label>
                    <span
                        className="font-mono text-[10px] tabular-nums text-[#8A93A6]"
                        data-testid="strategy-goals-count"
                    >
                        {form.goals.length}/3
                    </span>
                </div>
                <div
                    className="flex flex-wrap gap-2"
                    data-testid="strategy-goals-group"
                >
                    {GOAL_OPTIONS.map((g) => (
                        <Chip
                            key={g}
                            label={g}
                            selected={form.goals.includes(g)}
                            disabled={goalCap && !form.goals.includes(g)}
                            onToggle={() => toggleArrayField("goals", g, 3)}
                            testId={`strategy-goal-${g.toLowerCase().replace(/\s+/g, "-")}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
